<blankslate>
  <blankslate-icon icon="graph" />
  <blankslate-heading>{{ title() }}</blankslate-heading>
  @if (message()) {
    <blankslate-description>{{ message() }}</blankslate-description>
  }
</blankslate>
